<template>
  <div class="errorPage">
    <div class="dialogBox">
      <img src="/../static/SCRM-logo.jpg" alt="" class="logo_bg">
      <h1>Busy System</h1>
      <h2>Some thing Wrong</h2>
      <p>The resource requested could not be found on this server!</p>
    </div>  
  </div>
</template>




<script >


export default {
  components: {},
  data() {
    return {     
    };
  },

  methods: {}
};
</script>



<style>
</style>


// WEBPACK FOOTER //
// src/components/Error.vue